<template>
  <div
    v-if="questionGroup"
    class="flex icon-question w-full"
  >
    <img
      v-if="questionGroupImageUrl"
      class="icon-question__image"
      :src="questionGroupImageUrl"
      alt="Картинка"
    />
    <div class="icon-question__question">
      <p class="icon-question__description">{{ questionGroup.text }}</p>
      <div v-if="questionGroup.questions" class="w-full">
        <div
          v-for="question in questionGroup.questions"
          :key="question.id"
          class="icon-question__answer">
          <p v-if="question.text" class="icon-question__text">
            {{ question.text }}
          </p>
          <div class="icon-question__slider slider flex">
            <div
              v-for="(answer, index) in question.answers"
              :key="answer.id"
              class="slider__radio-wrap flex flex-column"
            >
              <input
                :id="`answer_${question.id}_${answer.id}`"
                :name="`answer_${question.id}`"
                type="radio"
                tabindex="1"
                @change="setAnswer"
                :value="answer.value"
                :data-answer="answer.id"
                :data-question="question.id"
                :checked="savedAnswersMap[question.id] === answer.id"
              />
              <label
                :style="`background-image: url(${require(`@/assets/images/new-test-icons/${
                  index === 0 ? 'neutral' : `${emotions[question.text]}${index}`
                }.png`)})`"
                :for="`answer_${question.id}_${answer.id}`"
              ></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRef, watch } from "@vue/runtime-core";
import useAnswers from "@/mixins/useAnswers";
import emotionsTable from "@/mixins/dictionaries/emotionIconsTable";
import {computed} from "@vue/reactivity";
export default {
  name: "icons-question-group",
  props: {
    questionGroup: {
      type: Object,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    missedGroup: {
      type: Number,
      default: 0,
    },
    savedAnswers: {
      type: Array,
      default: () => [],
    },
    questionGroupImageUrl: {
      type: String,
      default: "",
    }
  },
  setup(props, context) {
    const group = toRef(props, "questionGroup");
    const missedGroup = toRef(props, "missedGroup");
    const { setAnswer, clearAnswers } = useAnswers(context);
    const emotions = emotionsTable;

    const savedAnswersMap = computed(() => {
      const map = {};

      for (const item of props.savedAnswers) {
        map[item.question_id] = item.question_answer_id;
      }

      return map;
    });

    watch(group, () => {
      clearAnswers();
    });

    watch(missedGroup, () => {
      if (missedGroup.value === group.value.id) {
        clearAnswers();
      }
    });

    return {
      setAnswer,
      emotions,
      savedAnswersMap
    };
  },
};
</script>

<style lang="scss" scoped>
.icon-question {
  column-gap: 20px;

  &__image {
    display: block;
    max-width: 900px;
    max-height: 500px;
    margin-bottom: 15px;
    border-radius: 8px;
    -o-object-fit: contain;
    object-fit: contain;
    object-position: center;
  }

  &__description {
    font-size: 16px;
    font-weight: 600;
  }

  &__text {
    font-size: 16px;
    font-weight: 600;
  }

  &__answer {
    padding: 16px;
    width: 100%;
    background-color: var(--light-grey);
    border-radius: 10px;
    margin-top: 8px;

    p {
      flex: 1 0 15%;
    }
  }
  &__slider {
    flex: 1 1 auto;
    column-gap: 32px;

    @media (max-width: $mobile-breakpoint) {
      column-gap: 20px;
    }
  }
  &__question {
    flex: 1 1 50%;
    max-width: 800px;
  }

  @media (max-width: 1500px) {

    &__image {
      max-width: 90%;
      max-height: 300px;
      margin-right: 0;
    }
    // &__answer {
    //   p {
    //     flex: 1 0 auto;
    //   }
    // }
    &__question {
      width: 100%;
    }
  }

  @media (max-width: $tablet-breakpoint) {
    &__answer {
      padding: 20px 20px;
    }
  }

  @media (max-width: $tablet-breakpoint) {
    flex-direction: column;
  }

  @media (max-width: $tablet-breakpoint) {

    &__answer {
      flex-direction: column;
      p {
        flex: 1 1 auto;
        padding: 5px 0;
      }
    }

    &__slider {
      flex-wrap: wrap;
      margin-top: 8px;
      column-gap: 10px;
    }
  }

  @media (max-width: 600px) {
    &__answer {
      padding: 10px;
    }

    &__description {
      font-size: 16px;
    }
  }
}

.slider {
  &__radio-wrap {
    position: relative;
    label {
      display: inline-block;
      height: 60px;
      width: 60px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      background-blend-mode: multiply;
    }

    label::before {
      content: '';
      position: absolute;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      top: -5px;
      left: -5px;
    }

    label:hover::before {
      border: 1px solid var(--main-green);
    }

    input {
      display: none;
    }
  }

  &__radio-wrap input:checked ~ label::before {
    border: 5px solid var(--main-green);
  }

  @media (max-width: 1050px) {
    &__radio-wrap {
      flex-direction: row;
      margin: 3px;
    }

    label {
      padding-bottom: 0;
      height: 50px;
      width: 50px;
    }

    label::before {
      content: '';
      position: absolute;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      top: -5px;
      left: -5px;
    }
  }

  @media (max-width: $mobile-breakpoint) {
    &__radio-wrap {
      margin: 0;
    }
  }
}
</style>
